import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import classnames from "classnames"
import { connect } from "lib/core/store"
import "./PathListArchive.css"
import withPathItemMutations from "./withPathItemMutations"

const PathListArchive = function (props) {
  const { item, displayType, isArchiving, unSelectPathItem, archivePathItem } =
    props
  const { name, item_type } = item

  const className = classnames(
    "PathListArchive",
    `PathListArchive--${displayType}`
  )

  return (
    <div className={className}>
      <div className="PathListArchive__prompt">
        <h5>
          Delete <em>{name}</em>?
        </h5>
        <p>
          This will also delete discussions, notes, progress, and submissions.
        </p>
      </div>
      <div className="PathListArchive__action">
        <SubmitButton
          submitting={isArchiving}
          onClick={() => archivePathItem(item)}
          dangerous
        >
          Yes, Delete
        </SubmitButton>
        <Button
          onClick={() => unSelectPathItem()}
          styleType="blank"
          inverted={true}
        >
          Cancel
        </Button>
      </div>
    </div>
  )
}

PathListArchive.displayName = "PathListArchive"

const mapStateToProps = function (state, ownProps) {
  const { selection, archiving_selection, is_saving_selection } =
    state.pathAdminStore.state
  const { unSelectPathItem } = state.pathAdminStore.action

  const isArchiving = archiving_selection && is_saving_selection
  const displayType = (function () {
    switch (ownProps.item.item_type) {
      case "T":
        return "divider"
      case "G":
        return "lesson"
      case "A":
        return "step"
    }
  })()

  return _.assign(
    {},
    {
      displayType,
      isArchiving,
      unSelectPathItem
    },
    ownProps
  )
}

export default withPathItemMutations(
  connect(PathListArchive, "pathAdmin", mapStateToProps, [
    "selection",
    "archiving_selection",
    "is_saving_selection"
  ])
)
